import { render, staticRenderFns } from "./SwedishFika.vue?vue&type=template&id=c9fc9980&"
import script from "./SwedishFika.vue?vue&type=script&lang=js&"
export * from "./SwedishFika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports